import {createSvgIcon} from '@common/icons/create-svg-icon';

export const HeaderElIcon = createSvgIcon(
  <path d="M 5 2 L 5 22 L 8 22 L 8 13 L 16 13 L 16 22 L 19 22 L 19 2 L 16 2 L 16 10 L 8 10 L 8 2 Z " />,
  'FormElOutlined',
);
